"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  & > .", " {\n    display: flex;\n    justify-content: space-between;\n    padding: 5px;\n    flex-wrap: nowrap;\n    white-space: nowrap;\n\n    .arrow-item {\n      transform: rotate(-90deg);\n      cursor: pointer;\n      font-size: 10px;\n    }\n\n    &:hover {\n      background-color: #f0f0f0;\n    }\n\n    input {\n      & + label {\n        cursor: pointer;\n      }\n    }\n  }\n  .sub-options {\n    & > * {\n      padding-left: 15px;\n    }\n  }\n"])), function (props) {
  return props.mainDivClass;
});

exports.Container = Container;